/**
 * /agents — every agent some experiment points to. There is no "add agent": an
 * agent appears when its first experiment is saved.
 */

import { Plus } from "lucide-react";
import { Box } from "@/components/ui/box";
import { ButtonLink } from "@/components/ui/button";
import { PageHeader } from "@/components/ui/page";
import { EmptyState, QueryState } from "@/components/ui/states";
import { AgentsTable } from "./agents-table";
import { useAgents } from "./hooks";
import { ProjectAction } from "@/features/projects/project-action";

export function AgentsPage() {
  const agents = useAgents();
  const newExperiment = (
    <ProjectAction permission="experiments:write">
      <ButtonLink variant="primary" to="/experiments/new">
        <Plus size={14} strokeWidth={2.2} aria-hidden />
        New experiment
      </ButtonLink>
    </ProjectAction>
  );
  return (
    <>
      <PageHeader
        title="Agents"
        subtitle="The agents you have tested, each with its experiments. One appears when its first experiment is saved."
        actions={newExperiment}
      />
      <Box>
        <QueryState query={agents} what="agents">
          {agents.data?.length ? (
            <AgentsTable agents={agents.data} />
          ) : (
            <EmptyState title="No agents yet" action={newExperiment}>
              Start an experiment: pick a connection, then an agent and its version.
            </EmptyState>
          )}
        </QueryState>
      </Box>
    </>
  );
}
